import { gql } from "@apollo/client";

const DeleteDeviceMutation = gql`
  mutation deleteDeviceById($id: BigInt!) {
    deleteDeviceById(input: { id: $id }) {
      device {
        deviceName
      }
    }
  }
`;

const hash = "974f84f3553c1ddab3164634573af9726983018827d55bf0729c36c12357826d";
export { DeleteDeviceMutation, hash };
